import { appConfig } from "../components/AppConfig/variables";
import { getData } from "../components/Utilities/CommonFunc";
import {
  setLastRefreshData,
  setLoader,
  setRiskTypes,
  setRiskTypesArray,
  setRiskTypesMap,
} from "../store/globalStore";

export function getLastRefreshDate(username) {
  return (dispatch) => {
    dispatch(setLoader({ loaderKey: "getRefreshDate", loaderValue: true }));

    const url =
      appConfig.env[appConfig.current_env].rest_api_host +
      "/global/fetch_refresh_date";

    getData(url)
      .then((data) => {
        dispatch(
          setLoader({ loaderKey: "getRefreshDate", loaderValue: false })
        );

        const {operational, strategic, insights} = data.last_refresh_date || {};

        dispatch(setLastRefreshData({
          operational: operational,
          strategic: strategic,
          insights: insights
        }));
      })
      .catch(function (err) {
        console.log("Error occured fetching getLastRefreshDate !!");
        console.log(err);
      });
  };
}

export function getRiskTypes() {
  return (dispatch) => {
    dispatch(setLoader({ loaderKey: "riskTypes", loaderValue: true }));

    const url =
      appConfig.env[appConfig.current_env].rest_api_host +
      "/global/risk_list?risk_type=active_risks";

    getData(url)
      .then(({ data }) => {
        dispatch(setLoader({ loaderKey: "riskTypes", loaderValue: false }));

        dispatch(setRiskTypes(data));

        const riskTypeMap = {};
        const riskTypeArray = [];

        data.forEach((riskType) => {
          riskTypeMap[riskType.id] = riskType.value;
          riskTypeArray.push(riskType.id);
        });

        dispatch(setRiskTypesMap(riskTypeMap));
        dispatch(
          setRiskTypesArray(
            riskTypeArray.filter(
              (x) =>
                x !== "Single Source" &&
                x !== "Sole Source" &&
                x !== "Tier 1 Network Capacity Overutilization"
            )
          )
        );
      })
      .catch(function (err) {
        console.log("Error occured fetching getLastRefreshDate !!");
        console.log(err);
      });
  };
}
